// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2fBfR","loaderOuter":"PageOverlayLoader_loaderOuter__3poMm"};